import { render, staticRenderFns } from "./customTablePage.vue?vue&type=template&id=d90a7676"
import script from "./customTablePage.vue?vue&type=script&lang=js"
export * from "./customTablePage.vue?vue&type=script&lang=js"
import style0 from "./customTablePage.vue?vue&type=style&index=0&id=d90a7676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports